/**
 * Helper for Select2 jump selects to allow selecting the default/current entry
 */

import $ from 'jquery';
import 'jquery-ui/ui/widget';

import App from 'libs/app';

var openUrl = function(url) {
    if (url) {
        window.location = decodeURI(decodeURIComponent(url));
    }
};

$.widget('tud.jumpSelect', {
    _create: function () {
        var $elm    = this.element;
        $elm.on("select2:select", function (event) {
            openUrl($(this).val());
        });

        // When the currently selected item is selected again, Select2 doesn't
        // fire the select2:select event.
        // Thus, enable the selection of the currently selected option by listening
        // for the mousup event on the select2 option by our self.
        $elm.on('select2:open', function() {
            $elm.data("select2").$results.on('mouseup.mobileHelper', "[aria-selected=true]", function(e) {
                var index = $(this).index() + 1;
                var option = $('option:nth-child('+ index +')', $elm);
                openUrl(option.val());
            });
        }).on('select2:close', function() {
            $elm.data("select2").$results.off('mouseup.mobileHelper');
        });
    }
});

App.registerReadyHandler("mobileHelper", function () {
    $(".jump-select").jumpSelect();
}, ["combobox"]);
